import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { UnavailableDate } from './unavailable-date.model';
import { UnavailableDatePopupService } from './unavailable-date-popup.service';
import { UnavailableDateService } from './unavailable-date.service';

@Component({
    selector: 'jhi-unavailable-date-delete-dialog',
    templateUrl: './unavailable-date-delete-dialog.component.html'
})
export class UnavailableDateDeleteDialogComponent {

    unavailableDate: UnavailableDate;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private unavailableDateService: UnavailableDateService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['unavailableDate', 'schoolCalendar']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.unavailableDateService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'unavailableDateListModification',
                content: 'Deleted an unavailableDate'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-unavailable-date-delete-popup',
    template: ''
})
export class UnavailableDateDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private unavailableDatePopupService: UnavailableDatePopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.unavailableDatePopupService
                .open(UnavailableDateDeleteDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/unavailable-date/unavailable-date-delete-dialog.component.ts